//import { retry } from 'rxjs/operator/retry';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';


import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Actions, Effect } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import * as fromRoot from '../reducer/core.reducer';
import { VideoStats }  from '../reducer/core.reducer';
import { DataService } from '../../service/data';
import { EventInteraction } from '../../service/dynamic/event.interaction.service';
import { StateInteractionService } from '../../service/dynamic/state.interaction.service';
import * as coreActions from '../action/core.actions';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {APP_SETTINGS, MediaCellConfig } from '../../../modules/ng-express-engine/tokens';
import { Observable } from 'rxjs';
import { empty } from 'rxjs/observable/empty';
import { of } from 'rxjs/observable/of';
import { first } from 'rxjs/operator/first';
import { filter } from 'rxjs/operator/filter';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import { concat } from 'rxjs/observable/concat';
import { StateUserPipe } from './state-user.pipe'
import { StateInternalPipe }   from './state-internal.pipe';
import { StateDataPipe }   from './state-data.pipe';
import { StateSearchPipe } from './state-search.pipe';
import { StateRoutingPipe } from './state-routing.pipe';

@Injectable()
export class CoreEffects {
  private isServer: boolean;
  public searchSubscription: Subscription;
  public rowsSubscription: Subscription;

  constructor(
    private store: Store<fromRoot.State>,
    private actions$: Actions,
    private apiService: DataService,
    private router: Router,
    private stateInternal: StateInternalPipe,
    private stateData: StateDataPipe,
    private stateSearch: StateSearchPipe,
    private stateRouting: StateRoutingPipe,
    private stateUser: StateUserPipe,
    private activeRoute: ActivatedRoute,
    @Inject(APP_SETTINGS) private settings: Object,
    private eventInteraction: EventInteraction,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.isServer = isPlatformServer(this.platformId);
  }

  //  #region internal state
  public setInternalStateValue(key: string, value:any){
    this.stateInternal.setInternalStateValue(key, value);
  }
  public getInternalStateValue(key: string):any{
    return this.stateInternal.getInternalStateValue(key);
  }
  private processSlugState(routeParams: any, url: string){
    return this.stateInternal.processSlugState(routeParams, url);
  }
  private processHistoryState(routeParams: any){
    return this.stateInternal.processHistoryState(routeParams);
  }
  public checkAndSetInternalStateSelectedSlug(val){
    this.stateInternal.checkAndSetInternalStateSelectedSlug(val);
  }
  public checkAndSetInternalStateHistoryEmptyArray(){
    this.stateInternal.checkAndSetInternalStateSelectedSlug();
  }
  public setPopState(val, url){
    this.stateInternal.setPopState(val, url);
  }
  public getPopState(){
    return this.stateInternal.getPopState();
  }
  public setPopState2(val, url){
    this.stateInternal.setPopState2(val, url);
  }
  public wasPopped(popState){
    return this.stateInternal.wasPopped(popState);
  }
  public keepOverrides(overridingMeta: any, result: any){
    return this.stateInternal.keepOverrides(overridingMeta, result);
  }
  public getRowMetaFlags(sourceObject: Object,url: string, routeParams: object){
    return this.stateInternal.getRowMetaFlags(sourceObject, url, routeParams);
  }
  public handleInternalState(source: Object, routeParams: any, url: string, isContainer: boolean, notify: boolean, overridingMeta: any, maxCount? : number){
    return this.stateInternal.handleInternalState(source, routeParams, url, isContainer, notify, overridingMeta, maxCount);
  }
  // #endregion

  //  #region user state
  public login(){
    this.stateUser.login();
  } 
  public isLoggedIn(){
    return this.stateUser.isLoggedIn();
  }
  public setLoginState(state: boolean){
    this.stateUser.setLoginState(state);
  }
  public patchProfile(profile){
    return this.stateUser.patchProfile(profile);
  }
  public changePassword(newPassword: string){
    return this.stateUser.changePassword(newPassword);
  } 
  public processExistingUserVideoStats(){
    return this.stateUser.processExistingUserVideoStats();
  }
  public addOrRemoveFavorite(favoriteObj){
    return this.stateUser.addOrRemoveFavorite(favoriteObj);
  }
  public updateVideoStats( statObj ){
    this.stateUser.updateVideoStats(statObj);
  }
  public removeRegisteredDevice(deviceId){
    this.stateUser.removeRegisteredDevice(deviceId);
  }
  public getUserProfile() {
    return this.stateUser.getUserProfile()
  }
  public getUserOTTInfo() {
    return this.stateUser.getUserOTTInfo()
  }
  // #endregion

  //  #region data state
  public setInternalUrlListRootStateIfNeeded(url){
    const route = (url == "/") ? this.settings['HOME_ROUTE'] : url;
    const prevRootPage = this.stateInternal.getInternalStateValue('rootDetail');
    if (route != prevRootPage){
      this.setInternalUrlListRootState(route);
    }
  }
  public setInternalUrlListRootState(route){
    this.stateData.setInternalUrlListRootState(route);
  }
  public getRouteDataAsObservable(routeParams: Object, url: string = null, asyncChildren? : boolean): Observable<any> {
    return this.stateData.getRouteDataAsObservable(routeParams, url, asyncChildren);
  }
  public getRouteDataAsObservableEmit(dataSubject:BehaviorSubject<Object>,routeParams: Object, url: string = null, asyncChildren? : boolean){
    this.stateData.getRouteDataAsObservableEmit(dataSubject, routeParams, url, asyncChildren);
  }
  public getPollDataAsObservableEmit( dataSubject:BehaviorSubject<Object>, routeParams: Object){
    this.stateData.getPollDataAsObservableEmit(dataSubject, routeParams);
  }
  public getSeriesDailyEpisodeDataEmit(dataSubject:BehaviorSubject<Object>, meta: any, dateString: string){
      this.stateData.getSeriesDailyEpisodeDataEmit(dataSubject, meta, dateString);
  }
  public loadMetaInternalRoute(dataSubject:BehaviorSubject<Object>, meta: any){
    this.stateData.loadMetaInternalRoute(dataSubject, meta);
  }
  public getFreshData(url){
    return this.stateData.getFreshData(url);
  }
  public getAsyncChildDataAsObservable(dataService: any, item: object, routeParams: any, notify: boolean, maxCount?: number) {
    this.stateData.getAsyncChildDataAsObservable(dataService, item, routeParams, notify, maxCount);
  }
  public nextAsyncChildDataAsObservable(data: Array<object>, routeParams: any, notify: boolean, maxCount?: number){
    return this.stateData.nextAsyncChildDataAsObservable(data, routeParams, notify, maxCount);
  }
  public getFlattenedRowDataAsObservable( component : any, data: any, routeParams: any ) : Observable<any>{
    return this.stateData.getFlattenedRowDataAsObservable(component, data, routeParams);
  }
  public getAddressData( address : string ){
    return this.stateData.getAddressData(address);
  }
  public getApiUrlData(apiUrl: string, dispatch: boolean): Observable<any> {
    return this.stateData.getApiUrlData(apiUrl, dispatch);
  }
  public getApiUrlDataEmit(dataSubject:BehaviorSubject<Object>, apiUrl: string, dispatch: boolean){
    this.stateData.getApiUrlDataEmit(dataSubject, apiUrl, dispatch);
  }
  public cleanupDataEntities(){
    this.stateData.cleanupDataEntities();
  }
  public removeSeriesKey(key: string){
    this.stateData.removeSeriesKey(key);
  }
  public dispatchDataToStore(content: Object, url){
    this.stateData.dispatchDataToStore(content, url);
  }
  public deleteStaleSearchItems(term){
    this.stateData.deleteStaleSearchItems(term);
  }
  public deleteAllSearchItems(){
    this.stateData.deleteAllSearchItems();
  }
  public getStaticRouteData() {
    return this.stateData.getStaticRouteData(this.router.url, this.activeRoute.snapshot.params);
  }
  public getStoreData(routeParams: Object, url: string, maxCount?: number) {
    return this.stateData.getStoreData(routeParams, url, maxCount);
  }
  public getStaticRouteDataByUrl(url) {
    return this.stateData.getStaticRouteDataByUrl(url);
  }
  public dispatchNextSinglePage(url: string){
    this.stateData.dispatchNextSinglePage(url);
  }
  private dispatchNextPage(rows: Array<Object>){
    this.stateData.dispatchNextPage(rows);
  }
  public getRouteMeta(routeUrl: string){
    return this.stateRouting.getRouteMeta(routeUrl);
  }
  public getRouteRenderStyle(route: string){
    let target = this.getRouteMeta(route);
    return target ? target['renderStyle'] : 'list';
  }
  public getMergedMetaRows(rows : Array<Object>){
    return this.stateData.getMergedMetaRows(rows);
  }
  public getRouterData(routeParams: Object, routeUrl: string, dispatch?: boolean) {
    return this.apiService.getRouterData(routeParams, routeUrl, dispatch);
  }
  // #endregion

  // #region search state

  public search(terms: Observable<string>) {
    return terms.debounceTime(500)
        .distinctUntilChanged()
        .switchMap(term => this.stateSearch.searchEntries(term));
  }
  public searchByTerm(term: string, trimResults: boolean) : Observable<any> {
    return  this.stateSearch.searchByTerm(term, trimResults);
  }  
  public moreResultsBySearchTermAndCategory(row: Object){
    return this.stateSearch.moreResultsBySearchTermAndCategory(row);
  }
  public storeSearchSectionFirstRowOnHide(sectionName: string, searchTerm: string){
    this.stateSearch.storeSearchSectionFirstRowOnHide(sectionName, searchTerm);
  }
  public getSearchSectionFirstRowOnShow(sectionName: string, searchTerm: string){
    return this.stateSearch.getSearchSectionFirstRowOnShow(sectionName, searchTerm);
  }
  public removeSearchData(){
    this.stateSearch.removeSearchData();
  }
  // #endregion

  // #region navigation state 
  public getCmsRoutes(): Observable<any> {
    return this.stateRouting.getCmsRoutes();
  }
  public getCmsRoutesFromStore() : Array<Object>{
    return this.stateRouting.getCmsRoutesFromStore();
  }
  public processCmsRoutes(routesCopy: Array<object>, isRecursion: boolean, section: string) : Array<Object> {
    return this.stateRouting.processCmsRoutes(routesCopy, isRecursion, section);
  }
  // #endregion
  private navigate(newUrl?: string, isSlug?: boolean) {
    return Observable.of(null);
  }

 
  
  @Effect()
  getDataSlice$: Observable<Action> = this.actions$
    .ofType(coreActions.ActionTypes.GET_DATA_SLICE)
    .map((action: coreActions.GetDataSlice) => action.payload)
    .switchMap(action => {
      return this.apiService.getData({}, action["apiUrl"], 0, true).take(1)
        .map(content => new coreActions.GetDataSliceSuccess({ dataContent: content, apiUrl: action["apiUrl"] }))
        .catch(() => of(new coreActions.LoadDataItemFailAction({})));
    });

  @Effect()
  loadData$: Observable<Action> = this.actions$
    .ofType(coreActions.ActionTypes.LOAD_DATA_ITEM)
    .map((action: coreActions.LoadDataItemAction) => action.payload)
    .switchMap(action => {
      return this.apiService.getRouterData(action["routeParams"], action["apiUrl"]).take(1)
        .map(content => new coreActions.LoadDataItemSuccessAction({ dataContent: content, apiUrl: action["apiUrl"] }))
        .catch(() => of(new coreActions.LoadDataItemFailAction({})));
    });

  @Effect()
  loadDataComplete$: Observable<Action> = this.actions$
    .ofType(coreActions.ActionTypes.LOAD_DATA_ITEM_SUCCESS)
    .map((action: coreActions.LoadDataItemSuccessAction) => action.payload)
    .switchMap(action => {
      if (action['isSlug'] == null) {
        action['isSlug'] = false;
      }
      return this.navigate(null, action['isSlug'])
        .map(content => new coreActions.SelectDataItemByKeyAction(""))
        .catch(() => of(new coreActions.LoadDataItemFailAction({})));
    });


  @Effect()
  loadExistingDataItem$: Observable<Action> = this.actions$
    .ofType(coreActions.ActionTypes.LOAD_EXISTING_DATA_ITEM)
    .map((action: coreActions.LoadExistingDataItemAction) => action.payload)
    .switchMap(action => {
      if (action['isSlug'] == null) {
        action['isSlug'] = false;
      }
      return this.navigate(action["goTo"], action['isSlug'])
        .map(content => new coreActions.SelectDataItemByKeyAction(""))
        .catch(() => of(new coreActions.LoadDataItemFailAction({})));
    });

}



// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/effect/core.effects.ts